import { client } from '@/src/shared/api/axios';

import type { AuthResponse, LoginDto, RegisterDto } from './dto';

class AuthService {
  private readonly BASE_URL = '/api/auth';

  async register(data: RegisterDto) {
    const response = await client.post<AuthResponse>(
      `${this.BASE_URL}/register`,
      data,
    );
    return response.data;
  }

  async login(data: LoginDto) {
    const response = await client.post<AuthResponse>(
      `${this.BASE_URL}/login`,
      data,
    );
    return response.data;
  }

  async refresh() {
    const response = await client.post<AuthResponse>(
      `${this.BASE_URL}/refresh`,
    );
    return response.data;
  }

  async logout() {
    await client.post(`${this.BASE_URL}/logout`);
  }
}

export const authService = new AuthService();
